module.exports = __webpack_public_path__ + "img/sentra7.dfb6b8d1.jpeg";